import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import {
  ManagedTickerCreateRequest,
  ManagedTickerCreateResponse,
  ManagedTickerListRequest,
  ManagedTickerListResponse,
  ManagedTickerUpdateRequest,
} from './ticker-management-api.def.ts'

const interfaceName = 'manual-ticker'

export const tickerManagementApi = createApi({
  reducerPath: 'tickerManagementApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['managed-ticker'],
  endpoints: (build) => ({
    listManagedTickers: build.query<
      ManagedTickerListResponse,
      ManagedTickerListRequest
    >({
      query: (params) => ({
        url: '/list',
        method: 'GET',
        params: params,
      }),
      providesTags: ['managed-ticker'],
    }),
    createManagedTicker: build.mutation<
      ManagedTickerCreateResponse,
      ManagedTickerCreateRequest
    >({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['managed-ticker'],
    }),
    updateManagedTicker: build.mutation<
      ManagedTickerCreateResponse,
      ManagedTickerUpdateRequest
    >({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['managed-ticker'],
    }),
  }),
})

export const {
  useListManagedTickersQuery,
  useCreateManagedTickerMutation,
  useUpdateManagedTickerMutation,
} = tickerManagementApi
